import "./ManageFieldsButton.scss";

import ManageFieldsButton from "./ManageFieldsButton";

export default ManageFieldsButton;
